// extracted by mini-css-extract-plugin
export var actions = "_gq-g";
export var benefitCard = "_gq-b";
export var benefitIcon = "_gq-d";
export var benefitLabel = "_gq-f";
export var benefits = "_gq-a";
export var benefitsSection = "_gq-8";
export var bodyText = "_gq-7";
export var closeButton = "_gq-2";
export var content = "_gq-3";
export var eyebrow = "_gq-4";
export var heading = "_gq-5";
export var image = "_gq-i";
export var imagePanel = "_gq-h";
export var modal = "_gq-0";
export var offerCard = "_gq-c";
export var offerIcon = "_gq-e";
export var sectionLabel = "_gq-9";
export var shell = "_gq-1";
export var title = "_gq-6";